import clsx from 'clsx';
import React from 'react';
import { PageSkeleton } from '../ui';

interface IPageWrapper {
    loading?: boolean;
    title?: string;
    children: React.ReactNode;
    rootClassName?: string;
}

export function PageWrapper({
    loading,
    title,
    children,
    rootClassName,
}: Readonly<IPageWrapper>) {
    if (loading) {
        return (
            <div className="flex justify-center items-center">
                <PageSkeleton />
            </div>
        );
    }

    return (
        <div
            className={clsx(
                'bg-gray-50 min-h-full max-sm:pb-10 rounded-md pt-4 px-4 overflow-scroll',
                rootClassName
            )}
        >
            {title && (
                <div className="font-bold py-4 text-gray-400">{title}</div>
            )}
            {children}
        </div>
    );
}
